import { DomainConf } from "@wwg/domain-conf";

// Only one Segment write key exists today, so every domain points at it.
// Once dev/staging gets its own source, swap this constant for a per-domain
// value in each .forDomain() config below.
const SEGMENT_WRITE_KEY = "gA8xsTuL5BmJZFOlEUQzMWOFj0QIVRDV";

const env = new DomainConf()
  .forDomain("localhost", {
    apiBase: "https://dev-api.wwdb.com/v1/store",
    coreApiBase: "https://dev-api.wwdb.com/v1/core",
    localDevMode: true, // Set to true to enable local login for developers.
    environmentApp: "dev",
    segmentWriteKey: SEGMENT_WRITE_KEY,
  })
  .forDomain("wwg-store-dev.wwdb.com", {
    apiBase: "https://dev-api.wwdb.com/v1/store",
    coreApiBase: "https://dev-api.wwdb.com/v1/core",
    localDevMode: true,
    environmentApp: "dev",
    segmentWriteKey: SEGMENT_WRITE_KEY,
  })
  .forDomain("wwg-store.wwdb.com", {
    apiBase: "https://api.wwdb.com/v1/store",
    coreApiBase: "https://api.wwdb.com/v1/core",
    segmentWriteKey: SEGMENT_WRITE_KEY,
  });

export default env.current;
